export default __webpack_public_path__ + "static/media/ISAiCSO.cc3d6ceb.svg";